import InputLabel, { type InputLabelProps } from '@material-ui/core/InputLabel';
import { withStyles } from '@material-ui/core/styles';

import { colors, fonts } from '../styles/index';

export type BaseLabelProps = InputLabelProps;

export const labelStyle = {
  fontSize: fonts.size.small,
  color: colors.gray.dark,
  fontWeight: fonts.weight.medium,
  letterSpacing: 'normal',
  lineHeight: '19px',
};

// https://material-ui.com/api/input-label/#inputlabel-api
export const BaseLabel = withStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    ...labelStyle,
  },
  focused: {
    '&&': {
      // need to add this because it is overwritten when input is focused
      color: colors.gray.dark,
    },
  },
})(InputLabel);
